import { Box } from "@mui/material";
import Filter from "../../../../Components/filters/OrderFilters/OrderFilter";
import StatusTabs from "./StatusTabs";

const OrdersFilters = ({
  isLatestOrders,
  activeStatus,
  setActiveStatus,
  filterOpen,
  setFilterOpen,
  filterData,
  handleChangeFilter,
  onFilterClick,
  handleClearFilters,
  handleRemove,
  submittedData,
  orderStatus,
  type,
  triggerOverviewRefresh,
  FilterBtn,
  FilterBtnUp,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: isLatestOrders ? "flex-end" : "space-between",
          alignItems: "center",
          paddingBottom: "16px",
          backgroundColor: "white",
        }}
      >
        {!isLatestOrders && (
          <StatusTabs
            activeStatus={activeStatus}
            setActiveStatus={setActiveStatus}
            onTabChange={triggerOverviewRefresh}
          />
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src={filterOpen ? FilterBtnUp : FilterBtn}
            alt="Filter"
            style={{ cursor: "pointer" }}
            onClick={() => setFilterOpen(!filterOpen)}
          />
        </Box>
      </Box>
      <Filter
        filterOpen={filterOpen}
        filterData={filterData}
        handleChangeFilter={handleChangeFilter}
        handleFilter={onFilterClick}
        handleClearFilters={handleClearFilters}
        handleRemove={handleRemove}
        submittedData={submittedData}
        orderStatus={orderStatus}
        type={type}
      />
    </>
  );
};

export default OrdersFilters;
